export enum VideoPokerCardCombinationName {
    NOTHING = "NOTHING",
    JACKS_OR_BETTER = "JACKS_OR_BETTER",
    TWO_PAIRS = "TWO_PAIRS",
    THREE_OF_A_KIND = "THREE_OF_A_KIND",
    STRAIGHT = "STRAIGHT",
    FLUSH = "FLUSH",
    FULL_HOUSE = "FULL_HOUSE",
    FOUR_OF_A_KIND = "FOUR_OF_A_KIND",
    STRAIGHT_FLUSH = "STRAIGHT_FLUSH",
    ROYAL_FLUSH = "ROYAL_FLUSH",
}



// WEBPACK FOOTER //
// ./src/app/VideoPokerCardCombinationName.ts